import { Content } from './content';

export const CtaShowType = {
  overlay: 1,
  expand: 2,
} as const;

export type CtaShowType = typeof CtaShowType[keyof typeof CtaShowType];

export class CtaSimple extends Content{

  legacy: boolean = false; // 旧Ctaの場合:true ※trueの場合、変更不可、保存しない

  type:'CtaSimple';
  showType: CtaShowType = CtaShowType.overlay;
  showTiming: number = null;
  typeText:string;
  title:String;
  linkUrl:String;

  isShown:boolean = false; // すでに表示済みかを管理する  
  
  constructor(object = null){
    super();

    this.type = 'CtaSimple';

    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){
    super.set(object);

    if(object.legacy){
      this.legacy = object.legacy;
    }

    if(object.showType){
      this.showType = object.showType;
    }
    if(object.showTiming !== undefined && object.showTiming !== null){
      this.showTiming = Number(object.showTiming);
    }
    if(object.hash){
      this.hash = object.hash;
    }
    if(object.title){
      const title = object.title.replace('<br />', '\n');
      this.title = title.trim();
    }
    if(object.linkUrl){
      this.linkUrl = object.linkUrl;
    }

  }


}